const Modules = { print: '/print', market: '/market' }

const domain = {
  base: process.env.PUBLIC_PATH,
  baseModules: Modules,
  Modules: {
    // 前端页面地址
    index: '/',
    print3D: Modules.print + '/process/require', // 打印服务
    market: Modules.market + '/', // 创客集市
    usercenter: Modules.print + '/usercenter', // 个人中心
    profileH5: Modules.print + '/usercenter/account/profileH5', // 个人资料H5
    space: Modules.market + '/space/', // 创客集市-个人空间
    seller: Modules.market + '/seller', // 卖家中心
    marketmsg: Modules.market + '/message', // 创客集市-消息中心
    message: Modules.print + '/usercenter/message/messages', // 个人中心-消息中心
    order: Modules.print + '/usercenter/markets', // 个人中心-集市订单
    orderSimple: Modules.print + '/usercenter/trade/ordersSimple', // 个人中心-我的H5订单
    mycart: Modules.print + '/process/mycart', // 打印服务-购物车
    about: {
      // 底部关于
      clause: Modules.print + '/about/clause',
      declare: Modules.print + '/about/declare'
    }
  },
  Boot: {
    user: process.env.API_User,
    print: process.env.API_Print,
    market: process.env.API_Market
  },
  FileUri: {
    // 图片接口
    photoUri: process.env.API_Print + '/sys/user/loadPhoto/', // 头像照片
    modelImgUri: process.env.API_Print + '/model/loadImage/', // 模型图片
    modelDownloadUri: process.env.API_Print + '/model/download/', // 模型文件下载
    materialImgUri: process.env.API_Print + '/material/loadMaterialImage/', // 材料图片
    materialSurfaceImgUri: process.env.API_Print + '/material/loadSurfaceImage/', // 材料工艺图片
    marketDownloadnUri: process.env.API_Market + '/file/' // 创客集市图片下载
  },
  // 用户信息服务接口
  User: {
    // [POST] 用户登录
    login: '/sys/login_mobile_password',
    // [POST] 用户验证码登录
    loginByIc: '/sys/login_mobile_ic',
    // [POST] 用户快速注册
    register: '/api/register',
    // [PUT] 找回用户密码
    getPassword: '/api/getBackPassword',
    // [GET] 发送手机验证码
    code: '/api/sendIdentifyingCode',
    // [GET] 获取登录的用户信息
    info: '/sys/user/info'
  },
  Message: {
    // [SOCKET] 即时消息接口
    endpoint: process.env.API_Print + '/endpoint',
    // [SOCKET] 订阅即时消息
    subscribe: '/user/queue/private',
    // [GET] 根据条件查询消息
    list: '/imessage/list'
  },
  Order: {
    // [GET] 支付方式数据
    payment: '/order/paymentMethod/'
  },
  // 用户设定的材料参数信息
  Params: {
    // [GET] 根据条件查询用户设定的材料参数信息(用户设定的)
    list: '/material/listUserSettingMaterialParams',
    // [GET] 获得模型自动报价信息
    quote: '/model/getAutoQuotationInfo'
  },
  Model: {
    // [PUT] 匿名用户转为正式用户
    revise: '/model/anon2loginUser/'
  }
}

export default domain



// WEBPACK FOOTER //
// ./src/commons/store/domain.js